export default __webpack_public_path__ + "static/media/KP.24c2b809.svg";